import { ROUTE_SHIPPER_PROFILE } from './lib/shared/routes';

export * from './lib/shipper-feature-profile.module';
export { ROUTE_SHIPPER_PROFILE };
